<div *ngIf="isOpen" class="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999] p-4"
  (click)="onBackdropClick()">
  <div class="bg-white rounded-3xl max-w-sm w-full shadow-2xl overflow-hidden transform transition-all duration-300"
    (click)="$event.stopPropagation()">

    <!-- Top accent bar -->
    <div class="h-1.5 w-full bg-gradient-to-r from-[#D31148] to-[#ff6b9d]"></div>

    <div class="px-7 py-7">

      <!-- Icon -->
      <div class="flex justify-center mb-5">
        <div class="w-16 h-16 rounded-full bg-[#FFF0F3] flex items-center justify-center">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="#D31148" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
            <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" stroke="#D31148" stroke-width="2" stroke-linecap="round" />
          </svg>
        </div>
      </div>

      <!-- Title -->
      <h3 class="text-center text-xl font-bold text-gray-900 mb-2">Block User</h3>

      <!-- Message -->
      <p class="text-center text-sm text-gray-500 leading-relaxed mb-1">
        To block this user please type in <span class="font-semibold text-gray-700">"Safeword"</span>
      </p>
      <p *ngIf="targetName" class="text-center text-xs text-gray-400 mb-5">
        You're about to block <span class="font-semibold text-[#D31148]">{{ targetName }}</span>
      </p>
      <div *ngIf="!targetName" class="mb-5"></div>

      <!-- Safeword input -->
      <input type="text" [(ngModel)]="typedWord" (ngModelChange)="onTypedWordChange()" (keydown.enter)="onSubmit()"
        placeholder="Type Safeword…" autocomplete="off" spellcheck="false"
        class="w-full rounded-xl border bg-[#fafafa] px-4 py-2.5 text-sm text-gray-700 placeholder-gray-400 outline-none focus:ring-1 transition-colors"
        [ngClass]="showError
          ? 'border-red-400 focus:border-red-400 focus:ring-red-300'
          : 'border-[#e8e8e8] focus:border-[#D31148] focus:ring-[#D31148]'" />

      <p *ngIf="showError" class="mt-2 text-xs font-medium text-red-500">
        That doesn't match — type "Safeword" to confirm.
      </p>

      <!-- Buttons -->
      <div class="flex flex-col gap-3 mt-5">
        <button type="button" (click)="onSubmit()"
          class="w-full py-3 rounded-xl bg-[#D31148] text-white font-semibold text-sm
                 hover:bg-[#b80e3d] active:scale-[0.98] transition-all">
          Block
        </button>
        <button type="button" (click)="onCancel()"
          class="w-full py-3 rounded-xl border border-gray-200 text-gray-600 font-semibold text-sm
                 hover:bg-gray-50 active:scale-[0.98] transition-all">
          Cancel
        </button>
      </div>

    </div>
  </div>
</div>
